// @flow

export default {
  'admins':                 'admin',
  'admin_corporate_users':  'manager',
  'corporate_users':        'user'
};
